import { array } from 'js-md5';
import { socketClient } from './socket'
import systemCheck from './systemCheck'
import utils from './util'
import configs from '../../package.json'
var $base64 = require("js-base64").Base64;

var ws = ''
var scoketTime_send = null;
var scoketTime1min = null;
var systemCheck_ = systemCheck.getExplorerVersion()

//opCode 1
export function socketCreate(that){
    // 链接socket
    ws && ws.wsClose()
    let wsUrl = `${utils.getUrlKey('bId')}?fromId=${Number($base64.decode(window.localStorage.getItem('uid-web')))}&userSignId=${utils.getUrlKey('userSignId')}`
    ws = new socketClient(wsUrl, {
        opCode:1,
        roomNum:utils.getUrlKey('bId'),
        fromId:Number($base64.decode(window.localStorage.getItem('uid-web'))),
        userSignId:utils.getUrlKey('userSignId'),
        pageName:'problem',
    });
    ws.initWebSocket()
    .then(function(){
        scoket_Ecg(that)
        // ws.wsMessage(function(data){
        // })
    })
    .catch(function(){});

    that.ws = ws
}

 // scoket心跳 检测scoket链接是否正常
function scoket_Ecg(that){
    cloneXT()
    scoketTime1min = window.setTimeout(function () {
        socketSendMsg({
            opCode:0,
        })
        
        scoket_Ecg(that)
    }, 60000);
}

//清除心跳任务
function cloneXT(){
    scoketTime1min && clearTimeout(scoketTime1min)
}

function socketSendMsg(options){
    options.roomNum = utils.getUrlKey('bId'),
    options.fromId = Number($base64.decode(window.localStorage.getItem('uid-web'))),
    options.fromName = utils.getUrlKey('idName')
    options.userSignId = utils.getUrlKey('userSignId'),
    options.ticketNum = utils.getUrlKey('ticketNum'),
    options.youXunExamNum = utils.getUrlKey('youXunExamNum')?utils.getUrlKey('youXunExamNum'):'',
    options.questionIndex = options.questionIndex? options.questionIndex:window.localStorage.getItem('buttonNum')
    options.deviceName = systemCheck_.split(' ')[0],
    options.deviceSysVer = systemCheck_.split(' ')[1],
    options.appVer = configs.version,
    options.pageName = 'problem',
    options.content = options.content?options.content:''
    try {
        options.memory = ((window.performance.memory.usedJSHeapSize / window.performance.memory.totalJSHeapSize) * 100).toFixed(2),
        navigator.getBattery().then(res=>{
            options.battery = res.level * 100
            ws && ws.wsSend(options)
        })
    } catch (error) {
        options.memory = ''
        options.battery = ''
        ws && ws.wsSend(options)
    }
}

// 进入房间 100
export function wsSend100(){
    socketSendMsg({
        opCode:100,
    })
}

//断开链接 107 //后台自己判断
export function wsSend107(){
    socketSendMsg({
        opCode:107,
    })
}

//下载资源 204
export function wsSend204(){
    socketSendMsg({
        opCode:204,
    })
}

//下载成功 206
export function wsSend206(){
    socketSendMsg({
        opCode:206,
    })
}

//下载失败 207
export function wsSend207(){
    socketSendMsg({
        opCode:207,
    })
}

//解压失败 208
export function wsSend208(){
    socketSendMsg({
        opCode:208,
    })
}

//解压成功 209
export function wsSend209(that){
    socketSendMsg(
        Object.assign({
            opCode:209
        },
        getQuestionid(that))
    )
}

//答题 210
export function wsSend210(bId,questionId,moveData,serial=''){
    socketSendMsg(
        Object.assign({
            opCode:210
        }
        ,{
            paperQuestionId:bId,
            questionId:questionId,
        },
        {questionIndex:serial}
        ,getDataJson(moveData))
    )
}

//切换题目 211
export function wsSend211(that){
    socketSendMsg(
        Object.assign({
            opCode:211
        }
        ,getQuestionid(that)
        ,getDataJson(that))
    )
}

//上传oss 212
export function wsSend212(){
    socketSendMsg(
        Object.assign({
            opCode:212
        })
    )
}

//上传oss成功 213
export function wsSend213(){
    socketSendMsg(
        Object.assign({
            opCode:213
        })
    )
}

//上传oss失败 214
export function wsSend214(){
    socketSendMsg(
        Object.assign({
            opCode:214
        })
    )
}

//删除文件 215
export function wsSend215(){
    socketSendMsg(
        Object.assign({
            opCode:215
        })
    )
}

//交卷 216
export function wsSend216(that){
    socketSendMsg(
        Object.assign({
            opCode:216
        }
        ,getDataJson(that))
    )
}

//交卷成功 217
export function wsSend217(that){
    socketSendMsg(
        Object.assign({
            opCode:217
        }
        ,getDataJson(that))
    )
}

//交卷失败 218
export function wsSend218(that){
    socketSendMsg(
        Object.assign({
            opCode:218
        }
        ,getDataJson(that))
    )
}

//服务器推送消息 确认收到回复 219
export function wsSend219(that,uuid){
    socketSendMsg(
        Object.assign({
            opCode:219,
            content:uuid,
        }
        ,getDataJson(that))
    )
}

// 获取questionid
function getQuestionid(that){
    for (let i = 0; i < that.topicList.length; i++) {
        const element = that.topicList[i];
        for (let y = 0; y < element.questionList.length; y++) {
            const ele = element.questionList[y];
            if(that.buttonNum == ele.serial){
                return {
                    paperQuestionId:ele.bId,
                    questionId:ele.questionId,
                }
            }
        }
    }
    return {}
}
//获取json
function getDataJson(that){
    let jsonData = []
    let localData = window.localStorage.getItem('ceping-'+ $base64.decode(window.localStorage.getItem('uid-web'))+'-'+utils.getUrlKey('bId'))? JSON.parse(window.localStorage.getItem('ceping-'+ $base64.decode(window.localStorage.getItem('uid-web'))+'-'+utils.getUrlKey('bId'))):[]
    let switchNum_ = 0
    if(localData&&localData.dataList){
        switchNum_ = localData.switchNum
        localData.dataList.forEach(element => {
            jsonData.push(element.obj)
        });
    }
    let paperDataJson  = {
        uid:Number($base64.decode(window.localStorage.getItem('uid-web'))),
        paperId:that.allData.bId,
        startDateVal:that.firstStartDateVal,
        endDateVal:utils.fmtDate(new Date(),'yyyy-MM-dd hh:mm:ss'),
        examStatus:null,//【null=需后台阅卷 -1=未通过 1=通过】
        paperType:sessionStorage.getItem('orgId')? 'ACG':'USER_SIGN',// USER_SIGN=报名试卷(默认) ACG=音基试卷
        paperVer:that.allData.paperVer,
        userSignId:utils.getUrlKey('userSignId'),//用户报名主键id
        switchNum:switchNum_,//进入考试后切换浏览器标签数
        userPaperUuid:that.uuid1,
        jsonData:JSON.stringify(jsonData),
    }
    return {
        jsonVal:JSON.stringify(paperDataJson)
    }
}

export default {
    socketCreate,
    cloneXT,
    wsSend100,
    wsSend107,
    wsSend204,
    wsSend206,
    wsSend207,
    wsSend208,
    wsSend209,
    wsSend210,
    wsSend211,
    wsSend212,
    wsSend213,
    wsSend214,
    wsSend215,
    wsSend216,
    wsSend217,
    wsSend218,
    wsSend219,
}


// WEBPACK FOOTER //
// ./src/lib/socketMethod.js